import { useLocation, useParams } from "react-router-dom";

import StudentDetailsLayout from "../../../layouts/Student";

import ProfileEditPage from "../../../sub_components/student/personal";

import { useGetStudentDetails } from "../../../../hooks/students";

const StudentPersonalPage = () => {
  const location = useLocation();

  const { studentId: studentIdParam } = useParams();
  const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

  const { data: student, isLoading: isStudentLoading } = useGetStudentDetails(studentId);

  return (
    <StudentDetailsLayout
      goBackRoute={location.state?.goBackRoute ?? null}
      operation={studentId ? "update" : "create"}
      currentTab="Personal"
      title={student ? `${student.first_name} ${student.last_name}` : 'Add a Student'}
      error={false}
      linkedStatus={{
        isDataAvailable: !!studentId,
        linked: !!student?.date_linked,
        linkedDate: student?.date_linked ?? null,
        unlinkedDate: student?.date_unlinked ?? null,
      }}
      isStudentAdded={!!student}
    >
      <div className="immersion__common_details__sub_info_container">
        <div className="immersion__common_details__sub_info_view">
          <div className="immersion__common_details__sub_info__forms_container">
            <ProfileEditPage
              loading={isStudentLoading}
              studentId={studentId ?? null}
              student={student ?? null}
            />
          </div>
        </div>
      </div>
    </StudentDetailsLayout>
  );
};

export default StudentPersonalPage;
